import React, { useCallback } from 'react';
import { Tooltip } from 'antd';
import { AiOutlineRobot } from 'react-icons/ai';
import { MenuItemIcon, Text } from '@ydistri/ds';
import { useYbotDock } from './useYbotDock';
import { YbotTriggerButton } from './ybotDockTriggerStyledComponents';

interface YbotDockTriggerProps {
  /** Matches the left menu's own collapsed treatment. */
  isCollapsed: boolean;
}

// Toggles the dock from the left menu; renders nothing when ybot is unavailable.
const YbotDockTrigger: React.FC<YbotDockTriggerProps> = ({ isCollapsed }) => {
  const { isAvailable, isOpen, open, close } = useYbotDock();

  const handleClick = useCallback(() => (isOpen ? close() : open()), [close, isOpen, open]);

  if (!isAvailable) {
    return null;
  }

  return (
    <Tooltip title={isCollapsed ? 'Ybot' : undefined} placement="right">
      <YbotTriggerButton type="button" $isSelected={isOpen} onClick={handleClick} aria-label="Ybot">
        <MenuItemIcon>
          <AiOutlineRobot />
        </MenuItemIcon>
        {!isCollapsed && (
          <Text $size="large" $semiBold>
            Ybot
          </Text>
        )}
      </YbotTriggerButton>
    </Tooltip>
  );
};

export default YbotDockTrigger;
